import { FiatProvider, OptionType } from '@/pages/Donation/types'

export const formatFiatProviderToOption = (provider?: FiatProvider | null): OptionType | null => {
  if (!provider) {
    return null
  }

  return {
    code: provider.payment_method,
    name: provider.payment_method_name,
    icon: provider.icon,
  }
}
